/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerReportQueryResponse, IncidentInvestigationControllerReportPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerReport";

function getIncidentInvestigationControllerReportUrl(id: IncidentInvestigationControllerReportPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/incident-agent/investigations/${id}/report` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/report}
 */
export async function incidentInvestigationControllerReport(id: IncidentInvestigationControllerReportPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerReportQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentInvestigationControllerReportUrl(id).url.toString(), ... requestConfig })  
  return res.data
}